export const DATE_SEPARATOR = "><";
export const extractRangeFromString = (timeRange) => timeRange.split(DATE_SEPARATOR);
export const timeRangeTitle = (from, until) => `${from || "All time"} - ${until || "Now"}`;
